import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { Pagination, SearchTable, TableBody, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { jobworkMenu, StitchEntrylist } from '../../TitleList';
import { fetchJobworkPaymentData } from '../../../Store/PHPSlice/Jobwork/jobworkApi';
import { selectJobworkPaymentData } from '../../Selectors/JobworkSelector/JobworkSelect';


const JobworkPaymentReg = () => {
    const dispatch = useDispatch();
    const jobworklist = useSelector(selectJobworkPaymentData);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchJobworkPaymentData());
    }, [dispatch]);

    // console.log(jobworklist);
    const compData = Array.isArray(jobworklist.data) ? jobworklist.data.map((item, index) => (
        {
            serialNumber: index + 1,
            srno: item.ID,
            dt: item.dt,
            fdt: item.fdt,
            tdt: item.tdt,
            jobMemo: item.jobMemo,
            empId: item.empId,
            empNm: item.empNm,
            totamt: item.totamt,
            totqty: item.totqty,
            tds: item.tds,
            tdsamt: item.tdsamt,
            gst: item.gst,
            gstamt: item.gstamt,
            netamt: item.netamt,
            deamt: item.deamt,
            clothamt: item.clothamt,
            sts: item.sts,
            payableamt: item.payableamt,
            pay_sts: item.pay_sts,
            locId: item?.locId,
            locNm: item?.locNm,
            firmId: item?.firmId,
            firmNm: item?.firmNm
        }
    )) : [];

    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item.dt.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.empNm.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 10);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n ? 'active' : ''}`} onClick={() => handleChangeCPage(n)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);
    };

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const displayedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };

    return (
        <>
            <Titlebar data={jobworkMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Jobwork Payment Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>


                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                            />

                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'dt', label: 'Date' },
                                                { id: 'jobMemo', label: 'Vocher No.' },
                                                { id: 'fdt', label: 'From-To Date' },
                                                { id: 'locNm', label: 'Location' },
                                                { id: 'firmNm', label: 'Firm' },
                                                { id: 'empNm', label: 'Employee' },
                                                { id: 'totqty', label: 'Total Qty.' },
                                                { id: 'totamt', label: 'Total Amt.' },
                                                { id: 'tds', label: 'TDS' },
                                                { id: 'tdsamt', label: 'TDS Amt.' },
                                                { id: 'gst', label: 'GST' },
                                                { id: 'gstamt', label: 'GST Amt.' },
                                                { id: 'netamt', label: 'NET Amt.' },
                                                { id: 'deamt', label: 'Deduct Amt.' },
                                                { id: 'clothamt', label: 'Cloth Deduct_Amt.' },
                                                { id: 'payableamt', label: 'Payable Amt.' },
                                                { id: '', label: 'Payment Status' },
                                                { id: '', label: 'View' },
                                                { id: '', label: 'Delete' }
                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData.map((row) => (
                                            <TableBody
                                                key={row.srno}
                                                id={row.srno}
                                                dt={row.dt}
                                                fdt={row.fdt}
                                                tdt={row.tdt}
                                                jobMemo={row.jobMemo}
                                                empId={row.empId}
                                                empNm={row.empNm}
                                                totamt={row.totamt}
                                                totqty={row.totqty}
                                                tds={row.tds}
                                                tdsamt={row.tdsamt}
                                                gst={row.gst}
                                                gstamt={row.gstamt}
                                                netamt={row.netamt}
                                                deamt={row.deamt}
                                                clothamt={row.clothamt}
                                                payableamt={row.payableamt}
                                                sts={row.sts}
                                                pay_sts={row.pay_sts}
                                                locId={row.locId}
                                                locNm={row.locNm}
                                                firmId={row.firmId}
                                                firmNm={row.firmNm}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default JobworkPaymentReg;
